export default {
  "default-admin": () => import("/opt/render/project/src/layouts/DefaultAdmin.vue"),
  "default-auth": () => import("/opt/render/project/src/layouts/DefaultAuth.vue"),
  "default-auth-simple": () => import("/opt/render/project/src/layouts/DefaultAuthSimple.vue"),
  "default-not-found": () => import("/opt/render/project/src/layouts/DefaultNotFound.vue"),
  "default-public": () => import("/opt/render/project/src/layouts/DefaultPublic.vue"),
  "default-public-single": () => import("/opt/render/project/src/layouts/DefaultPublicSingle.vue")
}